import script from "./ExchangeSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ExchangeSettings.vue?vue&type=script&setup=true&lang=js"

import "./ExchangeSettings.vue?vue&type=style&index=0&id=6151c1e7&lang=css"

const __exports__ = script;

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QDrawer,QScrollArea,QOptionGroup,QBadge,QPageContainer,QPage,QTabs,QTab,QBanner,QTabPanels,QTabPanel,QSlider,QBtnToggle,QToggle,QSelect,QField,QExpansionItem,QItemSection});
